<template>
  <div>
    <div class="box-header">
      <h3 class="box-title title">Reglas de negocio</h3>
    </div>
    <div class="box box-success">
       <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"><img class="icon-space" src="/static/img/icons/exclamation-circle-solid-modal.png" style="padding-bottom:5px"> Reglas de Negocio</h3>
      </div>
      <div class="box-body">
        <div class="filterContainer">
          <div class="row">
            <div class="col-md-4">
              <div id="divAccountSelect" class="form-group">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
          <div class="col-md-4 form-interspace">
            <div class="form-group pull-left" style="padding-top:25px;">
              <router-link :to="{name: 'AlertRulesEntry', params: { accountCode: this.selectedAccount.code } }" tag="button" class="btn btn-success">Registrar Regla</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
      <div class="box box-success">
      <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub"><img class="icon-space" src="/static/img/icons/result.png" style="padding-bottom:3px"> RESULTADO BÚSQUEDA</h3>
    </div>

    <div class="box-body">
         <div id="tablaReglas">
        <div id="ruleTable">
          <vuetable 
            id="ruleTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :data="tableData"
            :css="tableCSS.table"
            @vuetable:row-clicked="onClick"
            @vuetable:loading="onLoading"        
            @vuetable:loaded="onLoaded"
            noDataTemplate="No se encontraron resultados"
          >
              <template slot="ruleCode" scope="props">
                <div id="Codigo">
                  <span >{{props.rowData.ruleCode}}</span>
                </div>
              </template>
                <template slot="ruleName" scope="props">
                <div id="Nombre">
                  <span >{{props.rowData.ruleName}}</span>
                </div>
              </template>
                <template slot="ruleItemType" scope="props">
                <div id="Tipo">
                  <span >{{props.rowData.ruleItemType}}</span>
                </div>
              </template>
                <template slot="ruleItemCode" scope="props">
                <div id="Codigo">
                  <span >{{props.rowData.ruleItemCode}}</span>
                </div>
              </template>
                <template slot="ruleOperator" scope="props">
                <div id="Operador">
                  <span >{{props.rowData.ruleOperator}}</span>
                </div>
              </template>
                <template slot="ruleValue" scope="props">
                <div id="Valor">
                  <span >{{props.rowData.ruleValue}}</span>
                </div>
              </template>
          </vuetable>
        </div>
       </div>

    </div>
   
       </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vuetable from 'vuetable-2'

export default {
  name: 'AlertRules',
  components: {
    Multiselect,
    Vuetable
  },
  data () {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      tableData: null,
      tableFields: [
        {
          name: '__slot:ruleCode',
          title: 'Código'
        },
        {
          name: '__slot:ruleName',
          title: 'Nombre'
        },
        {
          name: '__slot:ruleItemType',
          title: 'Tipo',
          callback: 'formatItemType'
        },
        {
          name: '__slot:ruleItemCode',
          title: 'Código'
        },
        {
          name: '__slot:ruleOperator',
          title: 'Operador',
          callback: 'formatOperator'
        },
        {
          name: '__slot:ruleValue',
          title: 'Valor'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      /* Options */
      optionsItemType: [],
      optionsOperator: []
    }
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
    if (this.$route.params.accountCode) {
      this.selectedAccount = this.optionsAccount.filter(item => item.code === this.$route.params.accountCode)[0]
    } else {
      this.selectedAccount = this.optionsAccount[0]
    }

    this.loadSelectData()
    this.loadTableData()
  },
  methods: {
    ...mapActions([
      'fetchAlertRulesItemTypes',
      'fetchAlertRulesOperators',
      'fetchAlertRulesList'
    ]),
    loadSelectData () {
      this.fetchAlertRulesItemTypes().then((data) => {
        if (data != null) {
          this.optionsItemType = data.map(item => ({
            code: item.code,
            name: item.text
          }))
        }
      })

      this.fetchAlertRulesOperators().then((data) => {
        if (data != null) {
          this.optionsOperator = data.map(item => ({
            code: item.code,
            name: item.text
          }))
        }
      })
    },
    loadTableData () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchAlertRulesList(this.selectedAccount.code).then((data) => {
        if (data != null) {
          this.tableData = data.map(item => ({
            accountCode: item.accountCode,
            ruleCode: item.alertRuleId,
            ruleName: item.name,
            ruleItemType: item.appliesTo,
            ruleItemCode: item.itemValue,
            ruleOperator: item.operator,
            ruleValue: item.targetValue
          }))

          this.loader.hide()
        }
      })
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.loadTableData()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
    },
    formatItemType (value) {
      let formattedVal = this.optionsItemType.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    formatOperator (value) {
      let formattedVal = this.optionsOperator.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].name : ''
    },
    onClick (row) {
      this.$router.push({ name: 'AlertRulesEntry', params: { accountCode: row.accountCode, ruleCode: row.ruleCode } })
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>

#tablaReglas{
  margin-left: 0!important;
  margin-left: 0!important;
}

#ruleTable tbody tr {
    cursor: pointer;
}

#divAccountSelect, #divSearchSelect{ 
  height: 34px;
}

#divAccountSelect.multiselect__tags, #divSearchSelect .multiselect__tags{ 
  border-radius: 0px !important;
  min-height: 34px;
  height: 34px;
}

#divAccountSelect .multiselect__select{ 
  border-radius: 0px !important;
  height: 34px;
}

@media screen and (max-width: 600px) {

 .vuetable-empty-result{
   text-align: center !important;
 }

  #documentTypeCode td{
    padding-left: 50%  !important
  }

   #ruleTable table {
      border: 0;
    }

   #ruleTable table thead {
      display: none;
    }

   #ruleTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
      border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #ruleTable table td {
      display: block;
      border: none !important;
      font-size: 12px;
      text-align: right;
      padding: 3px;
      padding-right: 8px;
      padding-left: 8px;
    }

   #ruleTable table td:last-child {
      border-bottom: 0;
    }

    #ruleTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#ruleTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }

</style>



// WEBPACK FOOTER //
// AlertRules.vue?0155947f